import { useEvent as o } from "../events.js";

function t(t, n) {
  o(t, "touchstart", n.onTouchStart), o(t, "touchmove", n.onTouchMove), o(t, "touchend", n.onTouchEnd);
}

export default t;